// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { 
//   FiRefreshCw, FiPlus, FiLink, FiDatabase, FiTrash2, FiSearch,
//   FiFileText, FiList, FiCircle, FiPlayCircle,
//   FiAlertCircle, FiCpu, FiEdit3, FiChevronDown, FiChevronUp, FiFilter, FiFolder, FiUploadCloud, FiGlobe,
//   FiCheckSquare // <--- FIXED: Added missing icon import
// } from 'react-icons/fi';

// const API_BASE = "https://maa.ycpay.in"; 
// const PREFIX = "/api/admin/support";

// export default function SupportAdmin() {
//   const [activeTab, setActiveTab] = useState('modules');
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   // --- Data States ---
//   const [modules, setModules] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [answers, setAnswers] = useState([]);
//   const [questions, setQuestions] = useState([]);
//   const [expandedQuestions, setExpandedQuestions] = useState({});
  
//   // Search & Filters
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterModuleId, setFilterModuleId] = useState('all');

//   // --- Form States ---
//   const [moduleName, setModuleName] = useState('');
//   const [catForm, setCatForm] = useState({ name: '', description: '', module_id: '' });
//   const [ansForm, setAnsForm] = useState({ media_type: 'text', content_text: '', module_id: '' });
//   const [ansFile, setAnsFile] = useState(null);

//   // --- AI Brain States (NEW) ---
//   const [kbUrl, setKbUrl] = useState('');
//   const [kbFile, setKbFile] = useState(null);

//   const [editingId, setEditingId] = useState(null);
//   const [mapForm, setMapForm] = useState({ 
//     module_id: '', 
//     category_id: '', 
//     question_text: '', 
//     answer_ids: [], 
//     selection_type: 'single' 
//   });

//   // --- 1. DATA FETCHERS ---
//   const fetchData = useCallback(async (endpoint, setter) => {
//     try {
//       const res = await fetch(`${API_BASE}${PREFIX}${endpoint}`);
//       if (res.ok) {
//         const data = await res.json();
//         setter(data || []);
//       }
//     } catch (e) { 
//       console.error(`Fetch Error [${endpoint}]:`, e);
//       setter([]);
//     }
//   }, []);

//   const refreshAll = useCallback(async () => {
//     setLoading(true);
//     await Promise.all([
//       fetchData('/modules', setModules),
//       fetchData('/categories', setCategories),
//       fetchData('/answers', setAnswers),
//       fetchData('/questions/all', setQuestions)
//     ]);
//     setLoading(false);
//   }, [fetchData]);

//   useEffect(() => { refreshAll(); }, [refreshAll]);

//   // --- 2. FILTERED DATA LOGIC ---
//   const filteredData = useMemo(() => {
//     const search = searchTerm.toLowerCase().trim();
//     if (activeTab === 'modules') return modules.filter(m => m.name.toLowerCase().includes(search));
//     if (activeTab === 'categories') return categories.filter(c => (c.name.toLowerCase().includes(search)) && (filterModuleId === 'all' || c.module_id?.toString() === filterModuleId));
//     if (activeTab === 'answers') return answers.filter(a => (a.content.toLowerCase().includes(search)) && (filterModuleId === 'all' || a.module_id?.toString() === filterModuleId));
//     if (activeTab === 'mapping') return questions.filter(q => (q.question_text.toLowerCase().includes(search)) && (filterModuleId === 'all' || q.module_id?.toString() === filterModuleId));
//     return [];
//   }, [activeTab, modules, categories, answers, questions, searchTerm, filterModuleId]);

//   // --- 3. SUBMISSION HANDLERS ---
//   const handlePost = async (path, body, isMultipart = false) => {
//     setSubmitting(true);
//     try {
//       const options = {
//         method: 'POST',
//         body: isMultipart ? body : JSON.stringify(body),
//       };
//       if (!isMultipart) options.headers = { 'Content-Type': 'application/json' };

//       const res = await fetch(`${API_BASE}${PREFIX}${path}`, options);
//       if (res.ok) {
//         alert("Action Successful!");
//         refreshAll();
//         // Reset forms
//         setEditingId(null);
//         setModuleName('');
//         setCatForm({ name: '', description: '', module_id: '' });
//         setAnsForm({ media_type: 'text', content_text: '', module_id: '' });
//         setAnsFile(null);
//         setKbUrl('');
//         setKbFile(null);
//       } else {
//         const err = await res.json();
//         alert(`Error: ${err.detail || "Request failed"}`);
//       }
//     } catch (e) { alert("Network Error"); }
//     finally { setSubmitting(false); }
//   };

//   const handleEdit = (q) => {
//     setEditingId(q.id);
//     setMapForm({
//       module_id: q.module_id?.toString() || '',
//       category_id: q.category_id?.toString() || '',
//       question_text: q.question_text,
//       answer_ids: q.answers?.map(a => a.id.toString()) || [],
//       selection_type: q.selection_type || 'single'
//     });
//     setActiveTab('mapping');
//   };

//   return (
//     <div className="min-h-screen bg-[#f1f5f9] p-4 md:p-10 font-sans text-slate-900">
//       <div className="max-w-7xl mx-auto">
        
//         {/* Page Header */}
//         <header className="flex justify-between items-center mb-10">
//           <div>
//             <h1 className="text-3xl font-black tracking-tight">Support Engine Admin</h1>
//             <p className="text-slate-500 text-sm">Manage Categorized Flows & AI Knowledge</p>
//           </div>
//           <button onClick={refreshAll} className="p-3 bg-white shadow-md rounded-xl hover:bg-slate-50 active:scale-95 transition-all">
//             <FiRefreshCw className={loading ? "animate-spin text-brand-700" : "text-slate-400"} />
//           </button>
//         </header>

//         {/* Navigation Tabs */}
//         <div className="flex flex-wrap gap-2 mb-8 bg-slate-200/50 p-1.5 rounded-2xl w-fit border border-slate-200">
//           {[
//             { id: 'modules', label: 'Modules', icon: <FiDatabase /> },
//             { id: 'categories', label: 'Categories', icon: <FiFolder /> },
//             { id: 'answers', label: 'Library', icon: <FiFileText /> },
//             { id: 'mapping', label: 'Workflow', icon: <FiLink /> },
//             { id: 'ai', label: 'AI Brain', icon: <FiCpu /> },
//           ].map(t => (
//             <button key={t.id} onClick={() => setActiveTab(t.id)} className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-xs font-bold transition-all ${activeTab === t.id ? "bg-white shadow-sm text-brand-700" : "text-slate-500 hover:text-slate-800"}`}>
//               {t.icon} {t.label}
//             </button>
//           ))}
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          
//           {/* LEFT COLUMN: REGISTRATION FORMS */}
//           <div className="lg:col-span-4">
//             <div className="bg-white p-6 rounded-[2rem] shadow-xl border border-white sticky top-10">
//               <h2 className="font-black mb-6 flex items-center gap-2 text-brand-700">
//                 {activeTab === 'ai' ? <FiCpu className="text-brand-700" /> : <FiPlus />} 
//                 {editingId ? 'Edit Entry' : activeTab === 'ai' ? 'Ingest Knowledge' : `Register ${activeTab === 'answers' ? 'Answer' : activeTab.slice(0,-1)}`}
//               </h2>

//               {activeTab === 'modules' && (
//                 <div className="space-y-4">
//                   <input placeholder="Module Name" className="w-full p-4 bg-slate-50 rounded-xl border outline-none" value={moduleName} onChange={e => setModuleName(e.target.value)} />
//                   <button disabled={submitting} onClick={() => handlePost('/modules', { name: moduleName })} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold shadow-lg">Save Module</button>
//                 </div>
//               )}

//               {activeTab === 'categories' && (
//                 <div className="space-y-4">
//                   <select className="w-full p-4 bg-slate-50 rounded-xl border" value={catForm.module_id} onChange={e => setCatForm({...catForm, module_id: e.target.value})}>
//                     <option value="">-- Target Module --</option>
//                     {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
//                   </select>
//                   <input placeholder="Category Name" className="w-full p-4 bg-slate-50 rounded-xl border" value={catForm.name} onChange={e => setCatForm({...catForm, name: e.target.value})} />
//                   <textarea placeholder="Description" className="w-full p-4 bg-slate-50 rounded-xl border h-24" value={catForm.description} onChange={e => setCatForm({...catForm, description: e.target.value})} />
//                   <button disabled={submitting} onClick={() => handlePost('/categories', catForm)} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold">Save Category</button>
//                 </div>
//               )}

//               {activeTab === 'answers' && (
//                 <div className="space-y-4">
//                   <select className="w-full p-4 bg-slate-50 rounded-xl border" value={ansForm.module_id} onChange={e => setAnsForm({...ansForm, module_id: e.target.value})}>
//                     <option value="">-- Global Answer (No Module) --</option>
//                     {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
//                   </select>
//                   <select className="w-full p-4 bg-slate-50 rounded-xl border font-bold" value={ansForm.media_type} onChange={e => setAnsForm({...ansForm, media_type: e.target.value})}>
//                     <option value="text">Text Message</option>
//                     <option value="video">Video Clip</option>
//                     <option value="image">Image/Photo</option>
//                     <option value="document">PDF/Document</option>
//                     <option value="audio">Voice/Audio</option>
//                   </select>

//                   {ansForm.media_type === 'text' ? (
//                     <textarea placeholder="Type your answer content here..." className="w-full p-4 bg-slate-50 rounded-xl border h-32 focus:ring-2 ring-brand-100" value={ansForm.content_text} onChange={e => setAnsForm({...ansForm, content_text: e.target.value})} />
//                   ) : (
//                     <div className="border-2 border-dashed border-slate-200 rounded-2xl p-6 text-center bg-slate-50">
//                       <input type="file" id="ans-file-upload" className="hidden" onChange={e => setAnsFile(e.target.files[0])} />
//                       <label htmlFor="ans-file-upload" className="cursor-pointer flex flex-col items-center">
//                         <FiUploadCloud className="text-brand-700 mb-2" size={32} />
//                         <span className="text-xs font-bold text-slate-500">{ansFile ? ansFile.name : `Click to upload ${ansForm.media_type}`}</span>
//                       </label>
//                     </div>
//                   )}

//                   <button disabled={submitting} onClick={() => {
//                     const fd = new FormData();
//                     fd.append('media_type', ansForm.media_type);
//                     if(ansForm.module_id) fd.append('module_id', ansForm.module_id);
//                     if(ansForm.media_type === 'text') { fd.append('content_text', ansForm.content_text); }
//                     else { if(ansFile) fd.append('file', ansFile); }
//                     handlePost('/answers/unified', fd, true);
//                   }} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold shadow-lg">Upload to Library</button>
//                 </div>
//               )}

//               {/* NEW: AI BRAIN FORM */}
//               {activeTab === 'ai' && (
//                 <div className="space-y-6">
//                   <div className="space-y-2">
//                     <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2"><FiGlobe /> Web Ingestion</p>
//                     <input placeholder="Enter Documentation URL..." className="w-full p-4 bg-slate-50 rounded-xl border outline-none focus:ring-2 ring-brand-100" value={kbUrl} onChange={e => setKbUrl(e.target.value)} />
//                   </div>

//                   <div className="relative py-2 flex items-center">
//                     <div className="flex-grow border-t border-slate-100"></div>
//                     <span className="flex-shrink mx-4 text-slate-300 text-[10px] font-bold uppercase">OR</span>
//                     <div className="flex-grow border-t border-slate-100"></div>
//                   </div>

//                   <div className="space-y-2">
//                     <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2"><FiFileText /> Document Ingestion</p>
//                     <div className="border-2 border-dashed border-brand-200 rounded-2xl p-8 text-center bg-brand-50/30">
//                       <input type="file" id="kb-file-upload" className="hidden" accept=".pdf,.docx,.xlsx" onChange={e => setKbFile(e.target.files[0])} />
//                       <label htmlFor="kb-file-upload" className="cursor-pointer flex flex-col items-center">
//                         <FiUploadCloud className="text-brand-700 mb-2" size={40} />
//                         <span className="text-xs font-bold text-slate-600">{kbFile ? kbFile.name : "Upload PDF, DOCX or XLSX"}</span>
//                         <span className="text-[9px] text-slate-400 mt-1">Files will be chunked and vectorized</span>
//                       </label>
//                     </div>
//                   </div>

//                   <button disabled={submitting || (!kbUrl && !kbFile)} onClick={() => {
//                     const fd = new FormData();
//                     if(kbUrl) fd.append('url', kbUrl);
//                     if(kbFile) fd.append('file', kbFile);
//                     handlePost('/admin/knowledge/upload', fd, true);
//                   }} className="w-full bg-slate-900 text-white p-4 rounded-xl font-bold shadow-xl flex items-center justify-center gap-2">
//                     <FiCpu /> {submitting ? "Absorbing..." : "Ingest to AI Brain"}
//                   </button>
//                 </div>
//               )}

//               {activeTab === 'mapping' && (
//                 <div className="space-y-4">
//                   <select className="w-full p-4 bg-slate-50 rounded-xl border" value={mapForm.module_id} onChange={e => setMapForm({...mapForm, module_id: e.target.value, category_id: ''})}>
//                     <option value="">-- 1. Select Module --</option>
//                     {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
//                   </select>
//                   <select className="w-full p-4 bg-slate-50 rounded-xl border" value={mapForm.category_id} onChange={e => setMapForm({...mapForm, category_id: e.target.value})} disabled={!mapForm.module_id}>
//                     <option value="">-- 2. Select Category --</option>
//                     {categories.filter(c => c.module_id?.toString() === mapForm.module_id).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
//                   </select>
//                   <input placeholder="3. Merchant Question Text" className="w-full p-4 bg-slate-50 rounded-xl border font-bold" value={mapForm.question_text} onChange={e => setMapForm({...mapForm, question_text: e.target.value})} />
//                   <div className="max-h-48 overflow-y-auto p-3 bg-slate-50 rounded-xl border">
//                     <p className="text-[10px] font-bold text-slate-400 mb-2 uppercase tracking-widest">4. Link Answer Library</p>
//                     {answers.filter(a => !mapForm.module_id || a.module_id?.toString() === mapForm.module_id).map(a => (
//                       <label key={a.id} className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer text-xs mb-1 transition-colors ${mapForm.answer_ids.includes(a.id.toString()) ? 'bg-brand-500 text-black' : 'hover:bg-white'}`}>
//                         <input type="checkbox" className="hidden" checked={mapForm.answer_ids.includes(a.id.toString())} onChange={() => {
//                           const ids = mapForm.answer_ids.includes(a.id.toString()) ? mapForm.answer_ids.filter(x => x !== a.id.toString()) : [...mapForm.answer_ids, a.id.toString()];
//                           setMapForm({...mapForm, answer_ids: ids});
//                         }} />
//                         <span className="truncate">[{a.media_type}] {a.content}</span>
//                       </label>
//                     ))}
//                   </div>
//                   <button onClick={() => handlePost('/questions', { ...mapForm, id: editingId })} className="w-full bg-slate-900 text-white p-4 rounded-xl font-bold uppercase">Sync Logic</button>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* RIGHT COLUMN: EXPLORER */}
//           <div className="lg:col-span-8">
//             <div className="bg-white rounded-[2.5rem] shadow-xl border border-white h-full flex flex-col overflow-hidden min-h-[600px]">
//               <div className="p-6 border-b flex flex-col md:flex-row justify-between gap-4 bg-slate-50/50">
//                 <div className="relative flex-1">
//                   <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
//                   <input className="w-full pl-12 pr-4 py-3 rounded-2xl bg-white border outline-none" placeholder={`Search ${activeTab}...`} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//                 </div>
//                 {activeTab !== 'ai' && (
//                   <div className="flex items-center gap-2 bg-white px-4 py-2 border rounded-2xl shadow-sm">
//                     <FiFilter className="text-slate-400" />
//                     <select className="text-xs font-bold outline-none uppercase bg-transparent" value={filterModuleId} onChange={e => setFilterModuleId(e.target.value)}>
//                       <option value="all">All Modules</option>
//                       {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
//                     </select>
//                   </div>
//                 )}
//               </div>

//               <div className="flex-1 overflow-y-auto p-6 space-y-4">
//                 {loading ? (
//                   <div className="flex justify-center py-20"><FiRefreshCw className="animate-spin text-brand-700" size={32} /></div>
//                 ) : filteredData.length === 0 && activeTab !== 'ai' ? (
//                   <div className="h-full flex flex-col items-center justify-center text-slate-300 py-20">
//                     <FiAlertCircle size={48} className="mb-2" />
//                     <p className="font-bold text-slate-500">No {activeTab} available</p>
//                   </div>
//                 ) : (
//                   <>
//                     {activeTab === 'ai' && (
//                       <div className="flex flex-col items-center justify-center h-full text-center p-10">
//                         <div className="w-20 h-20 bg-brand-100 text-brand-700 rounded-full flex items-center justify-center mb-6 shadow-inner">
//                           <FiCpu size={40} />
//                         </div>
//                         <h2 className="text-2xl font-black text-slate-800 mb-2">Knowledge Vector Engine</h2>
                        
                       
//                       </div>
//                     )}

//                     {activeTab === 'modules' && filteredData.map(m => (
//                       <div key={m.id} className="p-5 bg-slate-50 rounded-2xl border flex justify-between items-center hover:bg-white transition-all">
//                         <h3 className="font-black text-lg text-slate-800">{m.name}</h3>
//                         <FiTrash2 className="text-slate-300 hover:text-red-500 cursor-pointer" />
//                       </div>
//                     ))}

//                     {activeTab === 'categories' && filteredData.map(c => (
//                       <div key={c.id} className="p-5 bg-slate-50 rounded-2xl border flex flex-col gap-1 hover:bg-white transition-all">
//                         <span className="text-[10px] font-black bg-brand-100 text-brand-700 px-2 py-0.5 rounded uppercase w-fit">Module: {modules.find(m => m.id === c.module_id)?.name}</span>
//                         <h3 className="font-black text-lg text-slate-800">{c.name}</h3>
//                         <p className="text-xs text-slate-400 italic">{c.description}</p>
//                       </div>
//                     ))}

//                     {activeTab === 'mapping' && filteredData.map(q => {
//                       const expanded = expandedQuestions[q.id];
//                       return (
//                         <div key={q.id} className={`rounded-3xl border transition-all ${expanded ? 'bg-white shadow-lg' : 'bg-slate-50'}`}>
//                           <div className="p-5 flex justify-between items-center cursor-pointer" onClick={() => setExpandedQuestions(p => ({...p, [q.id]: !p[q.id]}))}>
//                             <div>
//                               <div className="flex gap-2 mb-1">
//                                 <span className="text-[8px] font-bold bg-slate-800 text-white px-2 py-0.5 rounded uppercase">{modules.find(m => m.id === q.module_id)?.name}</span>
//                                 <span className="text-[8px] font-bold bg-brand-500 text-ink px-2 py-0.5 rounded uppercase">{categories.find(c => c.id === q.category_id)?.name}</span>
//                               </div>
//                               <h4 className="font-bold">{q.question_text}</h4>
//                             </div>
//                             <div className="flex gap-4 items-center">
//                               <FiEdit3 className="text-brand-600" onClick={(e) => { e.stopPropagation(); handleEdit(q); }} />
//                               {expanded ? <FiChevronUp /> : <FiChevronDown />}
//                             </div>
//                           </div>
//                           {expanded && (
//                             <div className="px-6 pb-6 pt-2 bg-brand-50/10 border-t border-brand-50">
//                               {q.answers?.map(ans => (
//                                 <div key={ans.id} className="flex items-center gap-3 text-xs p-3 bg-white rounded-xl shadow-sm mb-2">
//                                   <FiCircle className="text-brand-700" />
//                                   <span className="font-black text-brand-700">[{ans.media_type}]</span>
//                                   <span className="truncate text-slate-600">{ans.content}</span>
//                                 </div>
//                               ))}
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}

//                     {activeTab === 'answers' && filteredData.map(a => (
//                       <div key={a.id} className="p-5 bg-slate-50 rounded-2xl border flex flex-col gap-2 hover:bg-white">
//                         <div className="flex justify-between items-center">
//                           <span className="text-[9px] font-black bg-brand-500 text-ink px-2 py-0.5 rounded uppercase">{a.media_type}</span>
//                           <span className="text-[9px] font-bold text-slate-400">ID: {a.id}</span>
//                         </div>
//                         <p className="text-sm font-bold text-slate-700 break-all">{a.content}</p>
//                       </div>
//                     ))}
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  FiRefreshCw, FiPlus, FiLink, FiDatabase, FiTrash2, FiSearch,
  FiFileText, FiList, FiCircle, FiPlayCircle,
  FiAlertCircle, FiCpu, FiEdit3, FiChevronDown, FiChevronUp, FiFilter, FiFolder, FiUploadCloud, FiGlobe,
  FiCheckSquare,
  FiShield, FiKey 
} from 'react-icons/fi';

// Same origin as the page. This used to name https://maa.ycpay.in, so every
// stack — the parallel one and any local run — edited the LIVE support content,
// and the cross-origin request carried no session cookie, which is a 401 now
// that the platform requires a token. nginx routes /api here (nginx.conf).
const API_BASE = "";
const PREFIX = "/api/admin/support";

export default function SupportAdmin() {
  const [activeTab, setActiveTab] = useState('modules');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // --- Data States ---
  const [modules, setModules] = useState([]);
  const [categories, setCategories] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [tiers, setTiers] = useState([]); // Fetched from the new /tiers API
  const [expandedQuestions, setExpandedQuestions] = useState({});
  
  // Search & Filters
  const [searchTerm, setSearchTerm] = useState('');
  const [filterModuleId, setFilterModuleId] = useState('all');

  // --- Form States ---
  const [moduleName, setModuleName] = useState('');
  const [catForm, setCatForm] = useState({ name: '', description: '', module_id: '' });
  const [ansForm, setAnsForm] = useState({ media_type: 'text', content_text: '', module_id: '' });
  const [ansFile, setAnsFile] = useState(null);

  // --- AI Brain States ---
  const [kbUrl, setKbUrl] = useState('');
  const [kbFile, setKbFile] = useState(null);

  const [editingId, setEditingId] = useState(null);
  const [mapForm, setMapForm] = useState({ 
    module_id: '', 
    category_id: '', 
    question_text: '', 
    answer_ids: [], 
    selection_type: 'single',
    user_type: 'all', // Default visibility
    report_key: ''    
  });

  // --- 1. DATA FETCHERS ---
  const fetchData = useCallback(async (endpoint, setter) => {
    try {
      const res = await fetch(`${API_BASE}${PREFIX}${endpoint}`, {
        credentials: 'include',
      });
      if (res.ok) {
        const data = await res.json();
        setter(data || []);
      }
    } catch (e) { 
      console.error(`Fetch Error [${endpoint}]:`, e);
      setter([]);
    }
  }, []);

  const refreshAll = useCallback(async () => {
    setLoading(true);
    await Promise.all([
      fetchData('/modules', setModules),
      fetchData('/categories', setCategories),
      fetchData('/answers', setAnswers),
      fetchData('/questions/all', setQuestions),
      fetchData('/tiers', setTiers) // New API integration
    ]);
    setLoading(false);
  }, [fetchData]);

  useEffect(() => { refreshAll(); }, [refreshAll]);

  // --- 2. FILTERED DATA LOGIC ---
  const filteredData = useMemo(() => {
    const search = searchTerm.toLowerCase().trim();
    if (activeTab === 'modules') return modules.filter(m => m.name.toLowerCase().includes(search));
    if (activeTab === 'categories') return categories.filter(c => (c.name.toLowerCase().includes(search)) && (filterModuleId === 'all' || c.module_id?.toString() === filterModuleId));
    if (activeTab === 'answers') return answers.filter(a => (a.content.toLowerCase().includes(search)) && (filterModuleId === 'all' || a.module_id?.toString() === filterModuleId));
    if (activeTab === 'mapping') return questions.filter(q => (q.question_text.toLowerCase().includes(search)) && (filterModuleId === 'all' || q.module_id?.toString() === filterModuleId));
    return [];
  }, [activeTab, modules, categories, answers, questions, searchTerm, filterModuleId]);

  // --- 3. SUBMISSION HANDLERS ---
  const handlePost = async (path, body, isMultipart = false) => {
    setSubmitting(true);
    try {
      const options = {
        method: 'POST',
        credentials: 'include',
        body: isMultipart ? body : JSON.stringify(body),
      };
      if (!isMultipart) options.headers = { 'Content-Type': 'application/json' };

      const res = await fetch(`${API_BASE}${PREFIX}${path}`, options);
      if (res.ok) {
        alert("Action Successful!");
        refreshAll();
        setEditingId(null);
        setModuleName('');
        setCatForm({ name: '', description: '', module_id: '' });
        setAnsForm({ media_type: 'text', content_text: '', module_id: '' });
        setAnsFile(null);
        setKbUrl('');
        setKbFile(null);
        setMapForm({ module_id: '', category_id: '', question_text: '', answer_ids: [], selection_type: 'single', user_type: 'all', report_key: '' });
      } else {
        const err = await res.json();
        alert(`Error: ${err.detail || "Request failed"}`);
      }
    } catch (e) { alert("Network Error"); }
    finally { setSubmitting(false); }
  };

  const handleEdit = (q) => {
    setEditingId(q.id);
    setMapForm({
      module_id: q.module_id?.toString() || '',
      category_id: q.category_id?.toString() || '',
      question_text: q.question_text,
      answer_ids: q.answers?.map(a => a.id.toString()) || [],
      selection_type: q.selection_type || 'single',
      user_type: q.user_type || 'all',
      report_key: q.report_key || ''
    });
    setActiveTab('mapping');
  };

  // Check if current mapping is a "Report" vs "Support"
  // If user_type is 'all', it's likely support. If it has a report_key, it's definitely a report.
  const isReportModule = useMemo(() => {
    const selectedModule = modules.find(m => m.id.toString() === mapForm.module_id);
    return selectedModule?.name?.toLowerCase().includes('report');
  }, [mapForm.module_id, modules]);

  return (
    <div className="min-h-screen bg-[#f1f5f9] p-4 sm:p-6 md:p-10 font-sans text-slate-900">
      <div className="max-w-7xl mx-auto">
        
        <header className="flex justify-between items-start gap-3 mb-6 md:mb-10">
          <div>
            <h1 className="text-2xl sm:text-3xl font-black tracking-tight">Support Engine Admin</h1>
            <p className="text-slate-500 text-sm">Manage Categorized Flows & AI Knowledge</p>
          </div>
          <button onClick={refreshAll} aria-label="Refresh" className="shrink-0 p-3 bg-white shadow-md rounded-xl hover:bg-slate-50 active:scale-95 transition-all">
            <FiRefreshCw className={loading ? "animate-spin text-brand-700" : "text-slate-400"} />
          </button>
        </header>

        <div className="-mx-4 mb-6 overflow-x-auto px-4 pb-1 sm:mx-0 sm:overflow-visible sm:px-0 md:mb-8">
          <div className="flex w-max gap-2 rounded-2xl border border-slate-200 bg-slate-200/50 p-1.5 sm:w-fit sm:flex-wrap">
          {[
            { id: 'modules', label: 'Modules', icon: <FiDatabase /> },
            { id: 'categories', label: 'Categories', icon: <FiFolder /> },
            { id: 'answers', label: 'Library', icon: <FiFileText /> },
            { id: 'mapping', label: 'Workflow', icon: <FiLink /> },
            { id: 'ai', label: 'AI Brain', icon: <FiCpu /> },
          ].map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)} className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-xl px-4 py-2.5 text-xs font-bold transition-all sm:px-6 ${activeTab === t.id ? "bg-white shadow-sm text-brand-700" : "text-slate-500 hover:text-slate-800"}`}>
              {t.icon} {t.label}
            </button>
          ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 sm:gap-6 lg:gap-8">
          
          <div className="lg:col-span-4">
            <div className="bg-white p-4 sm:p-6 rounded-[2rem] shadow-xl border border-white lg:sticky lg:top-10">
              <h2 className="font-black mb-6 flex items-center gap-2 text-brand-700">
                {activeTab === 'ai' ? <FiCpu className="text-brand-700" /> : <FiPlus />} 
                {editingId ? 'Edit Entry' : activeTab === 'ai' ? 'Ingest Knowledge' : `Register ${activeTab === 'answers' ? 'Answer' : activeTab.slice(0,-1)}`}
              </h2>

              {activeTab === 'modules' && (
                <div className="space-y-4">
                  <input placeholder="Module Name" className="w-full p-4 bg-slate-50 rounded-xl border outline-none" value={moduleName} onChange={e => setModuleName(e.target.value)} />
                  <button disabled={submitting} onClick={() => handlePost('/modules', { name: moduleName })} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold shadow-lg">Save Module</button>
                </div>
              )}

              {activeTab === 'categories' && (
                <div className="space-y-4">
                  <select className="w-full p-4 bg-slate-50 rounded-xl border" value={catForm.module_id} onChange={e => setCatForm({...catForm, module_id: e.target.value})}>
                    <option value="">-- Target Module --</option>
                    {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                  </select>
                  <input placeholder="Category Name" className="w-full p-4 bg-slate-50 rounded-xl border" value={catForm.name} onChange={e => setCatForm({...catForm, name: e.target.value})} />
                  <textarea placeholder="Description" className="w-full p-4 bg-slate-50 rounded-xl border h-24" value={catForm.description} onChange={e => setCatForm({...catForm, description: e.target.value})} />
                  <button disabled={submitting} onClick={() => handlePost('/categories', catForm)} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold">Save Category</button>
                </div>
              )}

              {activeTab === 'answers' && (
                <div className="space-y-4">
                  <select className="w-full p-4 bg-slate-50 rounded-xl border" value={ansForm.module_id} onChange={e => setAnsForm({...ansForm, module_id: e.target.value})}>
                    <option value="">-- Global Answer (No Module) --</option>
                    {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                  </select>
                  <select className="w-full p-4 bg-slate-50 rounded-xl border font-bold" value={ansForm.media_type} onChange={e => setAnsForm({...ansForm, media_type: e.target.value})}>
                    <option value="text">Text Message</option>
                    <option value="video">Video Clip</option>
                    <option value="image">Image/Photo</option>
                    <option value="document">PDF/Document</option>
                    <option value="audio">Voice/Audio</option>
                  </select>

                  {ansForm.media_type === 'text' ? (
                    <textarea placeholder="Type your answer content here..." className="w-full p-4 bg-slate-50 rounded-xl border h-32 focus:ring-2 ring-brand-100" value={ansForm.content_text} onChange={e => setAnsForm({...ansForm, content_text: e.target.value})} />
                  ) : (
                    <div className="border-2 border-dashed border-slate-200 rounded-2xl p-6 text-center bg-slate-50">
                      <input type="file" id="ans-file-upload" className="hidden" onChange={e => setAnsFile(e.target.files[0])} />
                      <label htmlFor="ans-file-upload" className="cursor-pointer flex flex-col items-center">
                        <FiUploadCloud className="text-brand-700 mb-2" size={32} />
                        <span className="text-xs font-bold text-slate-500">{ansFile ? ansFile.name : `Click to upload ${ansForm.media_type}`}</span>
                      </label>
                    </div>
                  )}

                  <button disabled={submitting} onClick={() => {
                    const fd = new FormData();
                    fd.append('media_type', ansForm.media_type);
                    if(ansForm.module_id) fd.append('module_id', ansForm.module_id);
                    if(ansForm.media_type === 'text') { fd.append('content_text', ansForm.content_text); }
                    else { if(ansFile) fd.append('file', ansFile); }
                    handlePost('/answers/unified', fd, true);
                  }} className="w-full bg-brand-500 text-ink p-4 rounded-xl font-bold shadow-lg">Upload to Library</button>
                </div>
              )}

              {activeTab === 'ai' && (
                <div className="space-y-6">
                  <div className="space-y-2">
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2"><FiGlobe /> Web Ingestion</p>
                    <input placeholder="Enter Documentation URL..." className="w-full p-4 bg-slate-50 rounded-xl border outline-none focus:ring-2 ring-brand-100" value={kbUrl} onChange={e => setKbUrl(e.target.value)} />
                  </div>

                  <div className="relative py-2 flex items-center">
                    <div className="flex-grow border-t border-slate-100"></div>
                    <span className="flex-shrink mx-4 text-slate-300 text-[10px] font-bold uppercase">OR</span>
                    <div className="flex-grow border-t border-slate-100"></div>
                  </div>

                  <div className="space-y-2">
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-2"><FiFileText /> Document Ingestion</p>
                    <div className="border-2 border-dashed border-brand-200 rounded-2xl p-8 text-center bg-brand-50/30">
                      <input type="file" id="kb-file-upload" className="hidden" accept=".pdf,.docx,.xlsx" onChange={e => setKbFile(e.target.files[0])} />
                      <label htmlFor="kb-file-upload" className="cursor-pointer flex flex-col items-center">
                        <FiUploadCloud className="text-brand-700 mb-2" size={40} />
                        <span className="text-xs font-bold text-slate-600">{kbFile ? kbFile.name : "Upload PDF, DOCX or XLSX"}</span>
                        <span className="text-[9px] text-slate-400 mt-1">Files will be chunked and vectorized</span>
                      </label>
                    </div>
                  </div>

                  <button disabled={submitting || (!kbUrl && !kbFile)} onClick={() => {
                    const fd = new FormData();
                    if(kbUrl) fd.append('url', kbUrl);
                    if(kbFile) fd.append('file', kbFile);
                    handlePost('/admin/knowledge/upload', fd, true);
                  }} className="w-full bg-slate-900 text-white p-4 rounded-xl font-bold shadow-xl flex items-center justify-center gap-2">
                    <FiCpu /> {submitting ? "Absorbing..." : "Ingest to AI Brain"}
                  </button>
                </div>
              )}

              {activeTab === 'mapping' && (
                <div className="space-y-4">
                  <select className="w-full p-4 bg-slate-50 rounded-xl border" value={mapForm.module_id} onChange={e => setMapForm({...mapForm, module_id: e.target.value, category_id: '', user_type: modules.find(m => m.id.toString() === e.target.value)?.name.toLowerCase().includes('report') ? 'basic' : 'all'})}>
                    <option value="">-- 1. Select Module --</option>
                    {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                  </select>
                  <select className="w-full p-4 bg-slate-50 rounded-xl border" value={mapForm.category_id} onChange={e => setMapForm({...mapForm, category_id: e.target.value})} disabled={!mapForm.module_id}>
                    <option value="">-- 2. Select Category --</option>
                    {categories.filter(c => c.module_id?.toString() === mapForm.module_id).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                  <input placeholder="3. Merchant Question Text" className="w-full p-4 bg-slate-50 rounded-xl border font-bold" value={mapForm.question_text} onChange={e => setMapForm({...mapForm, question_text: e.target.value})} />
                  
                  {/* Visibility Tier - Defaults to 'all' if not a report module */}
                  <div className="space-y-1">
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-1"><FiShield /> Visibility Tier</p>
                    <select className="w-full p-4 bg-brand-50/50 rounded-xl border border-brand-100 text-sm font-bold text-brand-700" value={mapForm.user_type} onChange={e => setMapForm({...mapForm, user_type: e.target.value})}>
                      {tiers.map(t => <option key={t.id} value={t.tier_name}>{t.tier_name.toUpperCase()}</option>)}
                    </select>
                  </div>

                  {/* Report Key - Immutable (disabled) if not a report module */}
                  <div className="space-y-1">
                    <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest flex items-center gap-1"><FiKey /> Report Key (Immutable for Support)</p>
                    <input 
                      placeholder={isReportModule ? "e.g. sales_snapshot" : "N/A for Support"} 
                      className={`w-full p-4 rounded-xl border text-sm font-mono ${isReportModule ? 'bg-brand-50/30 border-brand-100 text-brand-700 focus:ring-2 ring-brand-200 outline-none' : 'bg-slate-100 border-slate-200 text-slate-400 cursor-not-allowed'}`} 
                      value={isReportModule ? mapForm.report_key : ''} 
                      disabled={!isReportModule}
                      onChange={e => setMapForm({...mapForm, report_key: e.target.value})} 
                    />
                  </div>

                  <div className="max-h-48 overflow-y-auto p-3 bg-slate-50 rounded-xl border">
                    <p className="text-[10px] font-bold text-slate-400 mb-2 uppercase tracking-widest">4. Link Answer Library</p>
                    {answers.filter(a => !mapForm.module_id || a.module_id?.toString() === mapForm.module_id).map(a => (
                      <label key={a.id} className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer text-xs mb-1 transition-colors ${mapForm.answer_ids.includes(a.id.toString()) ? 'bg-brand-500 text-black' : 'hover:bg-white'}`}>
                        <input type="checkbox" className="hidden" checked={mapForm.answer_ids.includes(a.id.toString())} onChange={() => {
                          const ids = mapForm.answer_ids.includes(a.id.toString()) ? mapForm.answer_ids.filter(x => x !== a.id.toString()) : [...mapForm.answer_ids, a.id.toString()];
                          setMapForm({...mapForm, answer_ids: ids});
                        }} />
                        <span className="truncate">[{a.media_type}] {a.content}</span>
                      </label>
                    ))}
                  </div>
                  <button onClick={() => handlePost('/questions', { ...mapForm, id: editingId })} className="w-full bg-slate-900 text-white p-4 rounded-xl font-bold uppercase">Sync Logic</button>
                </div>
              )}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="bg-white rounded-[2rem] sm:rounded-[2.5rem] shadow-xl border border-white h-full flex flex-col overflow-hidden min-h-[420px] sm:min-h-[600px]">
              <div className="p-6 border-b flex flex-col md:flex-row justify-between gap-4 bg-slate-50/50">
                <div className="relative flex-1">
                  <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input className="w-full pl-12 pr-4 py-3 rounded-2xl bg-white border outline-none" placeholder={`Search ${activeTab}...`} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                </div>
                {activeTab !== 'ai' && (
                  <div className="flex items-center gap-2 bg-white px-4 py-2 border rounded-2xl shadow-sm">
                    <FiFilter className="text-slate-400" />
                    <select className="text-xs font-bold outline-none uppercase bg-transparent" value={filterModuleId} onChange={e => setFilterModuleId(e.target.value)}>
                      <option value="all">All Modules</option>
                      {modules.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                    </select>
                  </div>
                )}
              </div>

              <div className="flex-1 overflow-y-auto p-6 space-y-4">
                {loading ? (
                  <div className="flex justify-center py-20"><FiRefreshCw className="animate-spin text-brand-700" size={32} /></div>
                ) : filteredData.length === 0 && activeTab !== 'ai' ? (
                  <div className="h-full flex flex-col items-center justify-center text-slate-300 py-20">
                    <FiAlertCircle size={48} className="mb-2" />
                    <p className="font-bold text-slate-500">No {activeTab} available</p>
                  </div>
                ) : (
                  <>
                    {activeTab === 'ai' && (
                      <div className="flex flex-col items-center justify-center h-full text-center p-10">
                        <div className="w-20 h-20 bg-brand-100 text-brand-700 rounded-full flex items-center justify-center mb-6 shadow-inner">
                          <FiCpu size={40} />
                        </div>
                        <h2 className="text-xl sm:text-2xl font-black text-slate-800 mb-2">Knowledge Vector Engine</h2>
                      </div>
                    )}

                    {activeTab === 'modules' && filteredData.map(m => (
                      <div key={m.id} className="p-5 bg-slate-50 rounded-2xl border flex justify-between items-center hover:bg-white transition-all">
                        <h3 className="font-black text-lg text-slate-800">{m.name}</h3>
                        <FiTrash2 className="text-slate-300 hover:text-red-500 cursor-pointer" />
                      </div>
                    ))}

                    {activeTab === 'categories' && filteredData.map(c => (
                      <div key={c.id} className="p-5 bg-slate-50 rounded-2xl border flex flex-col gap-1 hover:bg-white transition-all">
                        <span className="text-[10px] font-black bg-brand-100 text-brand-700 px-2 py-0.5 rounded uppercase w-fit">Module: {modules.find(m => m.id === c.module_id)?.name}</span>
                        <h3 className="font-black text-lg text-slate-800">{c.name}</h3>
                        <p className="text-xs text-slate-400 italic">{c.description}</p>
                      </div>
                    ))}

                    {activeTab === 'mapping' && filteredData.map(q => {
                      const expanded = expandedQuestions[q.id];
                      return (
                        <div key={q.id} className={`rounded-3xl border transition-all ${expanded ? 'bg-white shadow-lg' : 'bg-slate-50'}`}>
                          <div className="p-5 flex justify-between items-center cursor-pointer" onClick={() => setExpandedQuestions(p => ({...p, [q.id]: !p[q.id]}))}>
                            <div>
                              <div className="flex gap-2 mb-1">
                                <span className="text-[8px] font-bold bg-slate-800 text-white px-2 py-0.5 rounded uppercase">{modules.find(m => m.id === q.module_id)?.name}</span>
                                <span className="text-[8px] font-bold bg-brand-500 text-ink px-2 py-0.5 rounded uppercase">{q.user_type || 'all'}</span>
                                {q.report_key && <span className="text-[8px] font-bold bg-brand-500 text-ink px-2 py-0.5 rounded uppercase">Key: {q.report_key}</span>}
                              </div>
                              <h4 className="font-bold">{q.question_text}</h4>
                            </div>
                            <div className="flex gap-4 items-center">
                              <FiEdit3 className="text-brand-600" onClick={(e) => { e.stopPropagation(); handleEdit(q); }} />
                              {expanded ? <FiChevronUp /> : <FiChevronDown />}
                            </div>
                          </div>
                          {expanded && (
                            <div className="px-6 pb-6 pt-2 bg-brand-50/10 border-t border-brand-50">
                              {q.answers?.map(ans => (
                                <div key={ans.id} className="flex items-center gap-3 text-xs p-3 bg-white rounded-xl shadow-sm mb-2">
                                  <FiCircle className="text-brand-700" />
                                  <span className="font-black text-brand-700">[{ans.media_type}]</span>
                                  <span className="truncate text-slate-600">{ans.content}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}

                    {activeTab === 'answers' && filteredData.map(a => (
                      <div key={a.id} className="p-5 bg-slate-50 rounded-2xl border flex flex-col gap-2 hover:bg-white">
                        <div className="flex justify-between items-center">
                          <span className="text-[9px] font-black bg-brand-500 text-ink px-2 py-0.5 rounded uppercase">{a.media_type}</span>
                          <span className="text-[9px] font-bold text-slate-400">ID: {a.id}</span>
                        </div>
                        <p className="text-sm font-bold text-slate-700 break-all">{a.content}</p>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}